import type { JsonApiResponseSingle } from 'json-api-normalizer';

import api from 'api/apiInstance';

export interface CustomSessionTimeoutOptions {
  id: number;
  allowCustomSessionTimeout: boolean;
  currentPassword: string;
}
export function updateAllowCustomSessionTimeout(path: string) {
  return {
    path,
    PATCH: (data: CustomSessionTimeoutOptions) =>
      api.patch<JsonApiResponseSingle>(path, {
        data: {
          attributes: {
            id: data.id,
            current_password: data.currentPassword,
            allow_custom_session_timeout: data.allowCustomSessionTimeout,
          },
        },
      }),
  };
}
